;(function () {
  'use strict'

  angular
    .module('contrast.navigation.history')
    .factory('URLHistoryService', URLHistoryService)

  function URLHistoryService($window, $location) {
    'ngInject'

    var PREVIOUS_URL_KEY = 'previousUrl'
    var NORTHSTAR_UI_URL = '/Contrast/cs/index.html#/'

    return {
      getPreviousUrl: getPreviousUrl,
      setPreviousUrl: setPreviousUrl,
      clearPreviousUrl: clearPreviousUrl,
      redirectToNewUiOrPreviousUrl: redirectToNewUiOrPreviousUrl
    }

    function getPreviousUrl() {
      return $window.localStorage.getItem(PREVIOUS_URL_KEY)
    }

    function setPreviousUrl(url) {
      $window.localStorage.setItem(PREVIOUS_URL_KEY, url)
    }

    function clearPreviousUrl() {
      $window.localStorage.removeItem(PREVIOUS_URL_KEY)
    }

    function redirectToNewUiOrPreviousUrl(previousUrl, clear) {
      // startsWith using regex since this file only supports ES5
      var startWith = new RegExp('^' + NORTHSTAR_UI_URL)

      if (startWith.test(previousUrl)) {
        var redirectUrl = previousUrl
        clearPreviousUrl()
        $window.location.href = redirectUrl
        return
      }

      $location.url(previousUrl, true)

      if (clear) {
        clearPreviousUrl()
      }
    }
  }
})()
